// @flow

import React from "react";
import { connect } from "react-redux";

import { useI18n, withI18n } from "@quantum/i18n";

import { compose } from "ramda";

import SelecaoCheckboxBase from "../../../comum/SelecaoCheckboxBase";

import {
  type ActionCreator,
  getTiposAjustePrecoSemProventos,
  selecionarAjustesPrecoSemProventos,
  getAjustesPrecoSemProventosSelecionados,
} from "../../../../state";
import { type Id, type TipoAjustePreco } from "../../../../model";

type Props = {
  listaAjustesPreco: Array<TipoAjustePreco>,
  ajustesPrecoSemProventosSelecionados: Array<Id>,
  selecionarAjustesPrecoSemProventos: ActionCreator,
};

const SelecaoAjusteDePrecoSemProventos = ({
  listaAjustesPreco,
  ajustesPrecoSemProventosSelecionados,
  selecionarAjustesPrecoSemProventos,
}: Props) => {
  const { translate } = useI18n();

  const onChangeAjustesPreco = ids => selecionarAjustesPrecoSemProventos(ids);

  return (
    <div className="ConfiguracaoMedida">
      <SelecaoCheckboxBase
        nomeSelecao={translate("configuracaoRelatorio.tipoDeAjuste")}
        itens={listaAjustesPreco}
        itensSelecionados={ajustesPrecoSemProventosSelecionados}
        onChange={onChangeAjustesPreco}
        campoId="id"
        campoDescricao="traducao"
      />
    </div>
  );
};

export default compose(
  withI18n,
  connect(
    (state, ownProps) => ({
      listaAjustesPreco: getTiposAjustePrecoSemProventos(state).map(ajuste => ({
        ...ajuste,
        traducao: ownProps.translate(ajuste.chaveTraducao),
      })),
      ajustesPrecoSemProventosSelecionados: getAjustesPrecoSemProventosSelecionados(
        state
      ),
    }),
    {
      selecionarAjustesPrecoSemProventos,
    }
  )
)(SelecaoAjusteDePrecoSemProventos);
